import { useObservable, useSubscription } from 'observable-hooks';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { Filters, TableFiltersChangedAction } from '..';

/**
 * Hook for setting up table filters with debouncing logic before the new filters values are dispatched
 *
 * @param initialFilters
 * @param filtersChanged
 * @returns
 */
export const useTableFilters = (initialFilters: Filters, filtersChanged: TableFiltersChangedAction) => {
    const dispatch = useDispatch();
    const filterState = useState<Filters>({});
    const [filters, setFilters] = filterState;

    useEffect(() => {
        setFilters(initialFilters);
    }, [initialFilters, setFilters]);

    useSubscription(
        useObservable(
            filters$ =>
                filters$.pipe(
                    distinctUntilChanged(),
                    debounceTime(200),
                    tap(([f]) => dispatch(filtersChanged(f)))
                ),
            [filters]
        )
    );

    return filterState;
};
